





























































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderApi from '@/api/order/list/newIndex'
import ViewUI from 'view-design'
import GoodsApi from '@/api/goods/list'
import ShopApi from '@/api/shopInfo/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class NewOrderList extends AbpBase {
  filters = [
    {
      label: '输入搜索',
      type: 'input',
      props: {
        placeholder: '订单编号',
      },
      key: 'orderNo',
    },
    {
      label: '收货人：',
      type: 'input',
      props: {
        placeholder: '收货人姓名/手机号码',
      },
      key: 'shippingInfo',
    },
    {
      label: '所属门店：',
      type: 'select',
      key: 'StoreId',
      props: {
        placeholder: '请选择',
        filterable: true,
      },
      options: [],
    },
    {
      label: '订单来源：',
      type: 'select',
      key: 'OrderSourceType',
      props: {
        placeholder: '请选择',
      },
      options: [
        {
          value: '0',
          text: '小程序',
        },
        {
          value: '1',
          text: 'PC商城',
        },
        {
          value: '2',
          text: '易神同步',
        },
      ],
    },
    {
      label: '下单时间',
      type: 'daterange',
      key: 'date',
      defaultValue: [],
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },

    {
      title: '店铺',
      key: 'storeName',
      align: 'center',
    },
    // {
    //   title: '商品信息',
    //   slot: 'orderItems',
    //   width: 320,
    //   align: 'center',
    // },
    {
      title: '订单金额',
      slot: 'payAmount',
      align: 'center',
    },
    {
      title: '定金',
      slot: 'deposit',
      align: 'center',
    },
    {
      title: '已发货金额',
      slot: 'futuresOrderAmount',
      align: 'center',
    },
    {
      title: '订单类型',
      slot: 'orderType',
      align: 'center',
    },
    {
      title: '发货完成度',
      slot: 'futuresOrderPercent',
      align: 'center',
    },
    {
      title: '是否已释放定金',
      slot: 'isRelease',
      align: 'center',
    },
    {
      title: '订单状态',
      slot: 'orderFullStatusStr',
      align: 'center',
    },
    {
      title: '下单时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '订单来源',
      key: 'orderSourceType',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  loading: boolean = false
  orderPrewModal: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  //订单整体状态 0 待支付/1 待发货/2 待收货/3 待评价/4 已取消/5 已评价/20 待成团
  tabList = [
    {
      text: '全部订单',
      value: null,
    },
    {
      text: '草稿单',
      value: 0,
    },
    {
      text: '已审核',
      value: 1,
    },
    {
      text: '已确认',
      value: 2,
    },

    {
      text: '已取消',
      value: 3,
    },
  ]
  activeTab = 0
  isCheckAll: boolean = false
  exporting: boolean = false
  selectedIds: any = new Set()
  cash: any = null
  selectedObj: any = {}

  conclusionObj: any = {
    releaseAmount: null,
    depositAmount: null
  }
  conclusionModal: boolean = false

  mounted() {
    // this.getCategoriesAll()
    this.getStoreList()
  }

  @Watch('$route', {
    immediate: true,
  })
  routeWatch() {
    ViewUI['LoadingBar'].finish()
    this.activeTab = 0
    this.page = {
      totalCount: 0,
      currentPage: 1,
      maxResultCount: 10,
    }
    this.tableData = []
    let form: any = this.$refs.lineForm
    if (form) {
      form.reset()
    }

    this.getOrderList()
  }
  // 同步导出订单
  exportExcel() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let { page, activeTab, tabList } = this
    this.exporting = true
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    // let date = form['date'] ? this.dateString(form['date'][0]) : null
    let StartTime = form['date'] ? this.dateString(form['date'][0]) : null
    let EndTime = form['date'] ? this.dateString(form['date'][1]) : null
    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value

    // let selection = (this.$refs.selection as any).getSelection()
    let OrderIds: any = [...this.selectedIds]
    // if (selection.length) {
    //   OrderIds = selection.map(item => item.id)
    // }
    OrderApi.exportExcel(
      // OrderIds ? page.maxResultCount : page.totalCount > 500 ? 500 : page.totalCount,
      page.totalCount,
      // OrderIds ? page.currentPage : 1,
      1,
      orderNo,
      shippingInfo,
      // date,
      orderFullStatus,
      orderType,
      '',
      OrderIds,
      StartTime,
      EndTime
    )
      .then((res) => {
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  // 异步导出订单
  exportExcelSync() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let { page, activeTab, tabList } = this
    this.exporting = true
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    let StartTime = form['date'] ? this.dateString(form['date'][0]) : null
    let EndTime = form['date'] ? this.dateString(form['date'][1]) : null
    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value

    let OrderIds: any = [...this.selectedIds]
    OrderApi.exportExcelSync(
      page.totalCount,
      1,
      orderNo,
      shippingInfo,
      // date,
      orderFullStatus,
      orderType,
      '',
      OrderIds,
      StartTime,
      EndTime
    )
      .then((res) => {
        this.exporting = false
        this.$Notice.success({
          desc: '创建任务成功',
        })
        this.$router.push({
          name: 'exportExcelRecord',
        })
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  // 导出记录
  exportExcelRecord() {
    this.$router.push({
      name: 'exportExcelRecord',
    })
  }

  get showBatchCancel() {
    return ![2, 3, 5, 4].includes(this.tabList[this.activeTab].value)
  }

  get showBatchDeleted() {
    return [null, 4, 6].includes(this.tabList[this.activeTab].value)
  }
  get showBatchPrint() {
    return [null, 1].includes(this.tabList[this.activeTab].value)
  }
  getOrderStatus(type) {
    if (type == 0) {
      return '草稿单'
    } else if (type == 1) {
      return '已审核'
    } else if (type == 2) {
      return '已确认'
    } else if (type == 3) {
      return '已取消'
    } else if (type == 5) {
      return '已结算'
    } else {
      return '-'
    }
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '订单列表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      this.getOrderList(form)
    } else {
      this.$Message.error('验证失败')
    }
  }

  orderTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '常规订单'
        break
      case 1:
        text = '拼团订单'
        break
      case 2:
        text = '积分订单'
        break
      case 3:
        text = '预售订单'
        break
    }

    return text
  }

  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
    setTimeout(() => {
      this.setChecked()
    }, 200)
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }
  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.filters.some((item) => {
          if (item.label == '商品分类：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.fullName,
              }
            })
            return true
          }
        })
      }
    })
  }
  // 获取门店列表
  getStoreList() {
    ShopApi.getList2(999, 0, '').then((res) => {
      console.log('门店列表', res)
      if (res.data.items) {
        this.filters.some((item) => {
          if (item.label == '所属门店：') {
            item.options = res.data.items.map((child) => {
              return {
                value: child.id,
                text: child.displayName,
              }
            })
            return true
          }
        })
      }
    })
  }
  /**
   * 获取订单列表
   */
  getOrderList(form?) {
    let { page, activeTab, tabList } = this
    this.loading = true
    this.isCheckAll = false
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    let productCategoryId = form ? form['productCategoryId'] : null
    let OrderSourceType = form && form['OrderSourceType'] ? Number(form['OrderSourceType']) : null
    let storeId = form && form['StoreId'] ? form['StoreId'] : null
    console.log('test', form)
    let date = form ? this.dateString(form['date']) : null
    let begin = form ? this.dateString(form['date'][0]) : null
    let end = form ? this.dateString(form['date'][1]) : null

    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value
    OrderApi.getOrderList(
      page.maxResultCount,
      page.currentPage,
      orderNo,
      shippingInfo,
      begin,
      end,
      orderFullStatus,
      orderType,
      '',
      '',
      storeId,
      productCategoryId,
      OrderSourceType
    )
      .then((res) => {
        this.loading = false
        if (res.data) {
          this.tableData = res.data.items
          page.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }
  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'orderDetail',
      query: {
        id: row.id,
      },
    })
  }
  // 审核订单
  examineOrder(row) {
    this.selectedObj = row
    this.cash = null
    this.orderPrewModal = true
  }
  submitExaminOrder() {
    if (!this.cash) {
      this.$Notice.warning({
        title: '请输入要收取的现金'
      })
    } else {
      let obj = {
        orderNo: this.selectedObj.orderNo,
        amount: this.cash
      }
      OrderApi.examineOrder(obj).then(res => {
        this.$Notice.success({ desc: '支付成功' })
        this.orderPrewModal = false
        this.submitFn()
      })
    }
  }
  submitConclusionOrder() {
    if(!this.conclusionObj.releaseAmount) {
      this.$Notice.warning({title: '请输入订单释放金额'})
      return
    }
    if(!this.conclusionObj.depositAmount) {
      this.$Notice.warning({title: '请输入订单扣除订金'})
      return
    }
    let obj = {
      depositAmount: this.conclusionObj.depositAmount,
      releaseAmount: this.conclusionObj.releaseAmount,
      orderNo: this.selectedObj.orderNo
    }
    this.loading = true
    OrderApi.completeOrder(obj).then(res => {
      this.$Notice.success({ desc: '释放成功' })
      this.submitFn()
      this.conclusionModal = false
      this.loading = false
    }).catch(err => {
      this.loading = false
    })
  }
  // 已支付订单
  areadyPay(row) {
    console.log(row)
    this.$Modal.confirm({
      title: '提示',
      content: '确认此订单为已支付订单吗？',
      onOk: () => {
        this.loading = true
        let list: any = [row.orderNo]
        OrderApi.changeOrderToAreadypay(list)
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '操作成功' })
            this.submitFn()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }
  /**
   * 批量发货
   */
  deliverGoodFn() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let idlist = selection.map((item) => item.id)
      this.$router.push({
        name: 'deliverGood',
        query: {
          id: JSON.stringify(idlist),
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择订单',
      })
    }
  }

  /**
   * 发货
   */
  shipmentFN(row) {
    this.$router.push({
      name: 'deliverGood',
      query: {
        id: row.id,
      },
    })
  }

  /**
   * 取消待付款订单
   */
  cancelOrder(row) {
    this.$Modal.confirm({
      title: '提示',
      content: '确认取消此订单？',
      onOk: () => {
        this.loading = true
        let list: any = [row.id]
        OrderApi.cancelOrder(list)
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '取消成功' })
            this.submitFn()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }
  // 订单审结
  conclusion(row) {
    if (row.isRelease) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认要审结此订单吗？',
        onOk: () => {
          let obj = {
            depositAmount: 0,
            releaseAmount: 0,
            orderNo: row.orderNo
          }
          OrderApi.completeOrder(obj)
            .then((res) => {
              this.$Notice.success({ desc: '审结成功' })
              this.submitFn()
            })
        },
      })
    }else {
      this.conclusionObj = {
        depositAmount: null,
        releaseAmount: null
      }
      this.selectedObj = row
      this.conclusionModal = true
    }
  }
  releaseDeposit(row) {
    this.$Modal.confirm({
      title: '提示',
      content: '确认释放此订单的定金吗？',
      onOk: () => {
        OrderApi.releaseDeposit(row.orderNo)
          .then((res) => {
            this.$Notice.success({ desc: '释放成功' })
            this.submitFn()
          })
      },
    })
  }

  cancelOrderAll() {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selection.forEach((x) => {
      if (x.orderFullStatus < 2 || x.orderFullStatus == 20) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待支付订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: '确认取消已选中的待支付订单？',
        onOk: () => {
          this.loading = true
          OrderApi.cancelOrder(ids)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '取消成功' })
              this.submitFn()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    }
  }
  // 批量已支付
  batchOrderAreadyPay() {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selection.forEach((x) => {
      if (x.orderFullStatus < 2 || x.orderFullStatus == 20) {
        ids.push(x.orderNo)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待支付订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: '确认已选中的待支付订单为已支付订单？',
        onOk: () => {
          this.loading = true
          OrderApi.changeOrderToAreadypay(ids)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '操作成功' })
              this.submitFn()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    }
  }
  // 批量审核 批量确认 批量结算
  batchOrderAction(type) {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    if (type == 'examine') {
      selection.forEach((x) => {
        if (x.orderStatus == 0) {
          ids.push(x.id)
        }
      })
    } else if (type == 'sure') {
      selection.forEach((x) => {
        if (x.orderStatus == 1) {
          ids.push(x.id)
        }
      })
    } else {
      selection.forEach((x) => {
        if (x.orderStatus == 2) {
          ids.push(x.id)
        }
      })
    }

    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待需要操作的订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: `确认已选中的订单为${type == 'examine' ? '已审核' : type == 'sure' ? '已确认' : '已结算'}订单？`,
        onOk: () => {
          let orderStatus = type == 'examine' ? 1 : type == 'sure' ? 2 : 5
          OrderApi.changeOrderStatus(orderStatus, ids)
            .then((res) => {
              this.$Notice.success({ desc: '操作成功' })
              this.submitFn()
            })
            .catch((err) => { })
        },
      })
    }
  }

  /**
   * 批量删除已取消/已关闭订单
   */
  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any = []
    selection.forEach((x) => {
      if (x.orderFullStatus === 4 || x.orderFullStatus === 6) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选已取消订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: `确认删除已取消订单？`,
        onOk: () => {
          this.loading = true
          OrderApi.deleteOrder(ids)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '删除成功' })
              this.submitFn()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    }
  }

  handleTableAllCancel() {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    })
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    })
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
      ; (this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  handleSelect(slection, row) {
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    this.selectedIds.delete(row.id)
  }
  setChecked() {
    // 找到绑定的table的ref对应的dom，找到table的objData对象，objData保存的是当前页的数据
    let objData = (this.$refs.selection as any).objData
    for (let index in objData) {
      if (this.selectedIds.has(objData[index].id)) {
        // cy 弊端 每次切换select都会触发table的on-select事件
        // this.$refs.purchaseTable.toggleSelect(index) // 在保存选中的ids的set合集里找与当前页数据id一样的行，使用toggleSelect（index），将这一行选中
        // cy 改进
        objData[index]._isChecked = true
      }
    }
    // console.log(objData)
  }
  // 打印发货单
  printOrder() {
    var selected = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selected.forEach((x) => {
      if (x.orderFullStatus === 1) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待发货订单' })
      return
    } else {
      this.$router.push({
        name: 'printOrder',
        params: {
          ids: encodeURIComponent(ids.join(',')),
        },
      })
    }
  }
  // 推送到管易
  pushToManage(row) {
    this.loading = true
    OrderApi.erpOrder(row.orderNo)
      .then((res) => {
        this.loading = false
        this.$Notice.success({ desc: '推送成功' })
        this.submitFn()
      })
      .catch((err) => {
        this.loading = false
      })
  }
}
